import React from "react";
import { AnimatedSection } from "./IntersectionObserver.tsx";

const Technology: React.FC = () => {
  const technologies = [
    ".NET/Node",
    "Next/Nuxt/Angular",
    "Платежи (Adyen/Stripe)",
    "CDP/ESP",
    "Algolia/Elastic",
    "Vercel/Azure"
  ];

  return (
    <section id="technology" className="technology-section pad-xlarge">
      <div className="dark-container">
        <AnimatedSection>
          <div className="section-header">
            <h2 className="display-medium">Стек и интеграции</h2>
            <p className="body-large section-subtitle">
              Headless и кастомные решения, адаптированные под ваши бизнес-процессы.
              Мы выбираем стек для скорости, редактируемости и масштабирования.
            </p>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={1}>
          <div className="technology-grid">
            {technologies.map((tech: string, index: number) => (
              <div key={index} className="tech-item">
                <span className="tech-name">{tech}</span>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Technology;